import {
    GOLD_CERT_TYPE_PAST,
    SILVER_CERT_TYPE_PAST,
    BRONZE_CERT_TYPE_PAST,
    CERT_VALUES
} from './certificates-constants';

// eslint-disable-next-line max-len
export const DOWNLOAD_URL_ALL_STUDENTS_ALL_CERTS = '@SchoolUsageReportsGatewayBaseUrl/School/Download/Classroom/Certificates';
export const DOWNLOAD_URL_ALL_STUDENTS_ALL_NEW_CERTS = '@CertificateGatewayBaseUrl/new-certificates/export';
export const DOWNLOAD_URL_ALL_STUDENTS_GOLD_CERTS =
    generateUrlAllStudentsCertsForType(CERT_VALUES[GOLD_CERT_TYPE_PAST]);
export const DOWNLOAD_URL_ALL_STUDENTS_SILVER_CERTS =
    generateUrlAllStudentsCertsForType(CERT_VALUES[SILVER_CERT_TYPE_PAST]);
export const DOWNLOAD_URL_ALL_STUDENTS_BRONZE_CERTS =
    generateUrlAllStudentsCertsForType(CERT_VALUES[BRONZE_CERT_TYPE_PAST]);

export function generateUrlAllStudentsCertsForType(type) {
    return `@CertificateGatewayBaseUrl/certificates/types/${type}/export`;
}

export function generateUrlStudentCertsForType(userProfileId) {
    return `@CertificateGatewayBaseUrl/certificates/students/${userProfileId}/export`;
}

export function generateUrlStudentNewCerts(userId) {
    return `@CertificateGatewayBaseUrl/new-certificates/students/${userId}/export`;
}

export function generateUrlAllStudentsNewCertsForType(type) {
    return `@CertificateGatewayBaseUrl/new-certificates/types/${type}/export`;
}

export function generateUrlStudentNewCertsForType({ userId, type }) {
    return `@CertificateGatewayBaseUrl/new-certificates/students/${userId}/types/${type}/export`;
}

export const FULL_COLOR = 'fullColor';
export const PRINT_FRIENDLY = 'printFriendly';
export const ALL_PAST = 'allPast';
export const ALL_NEW = 'allNew';




// WEBPACK FOOTER //
// ./containers/certificates/download-constants.js